import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/vivogolfTheme';
import TournamentsPage from './pages/TournamentsPage';
import MiniGamesPage from './pages/MiniGamesPage';
import MiniGameDetailPage from './pages/MiniGameDetailPage';
import PrizesPage from './pages/PrizesPage';
import AdminLeaderboardPage from './pages/AdminLeaderboardPage';
import UsersPage from './pages/UsersPage';
import TvLeaderboardPage from './pages/TvLeaderboardPage';
import AdminClassification from './pages/AdminClassification';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<MiniGamesPage />} />
          <Route path="/tournaments" element={<TournamentsPage />} />
          <Route path="/games" element={<MiniGamesPage />} />
          <Route path="/game" element={<MiniGameDetailPage />} />
          <Route path="/prizes" element={<PrizesPage />} />
          <Route path="/adminleaderboard" element={<AdminLeaderboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/leaderboard" element={<TvLeaderboardPage />} />
          <Route path="/ranking" element={<AdminClassification />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
